export default class StatDoesNotExistError extends Error {
  statId: string;

  constructor(statId: string) {
    super(`Stat doesn't exist for id: ${statId}`);
    this.statId = statId;
  }
}
